import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M6 4h12c.5523 0 1 .4477 1 1v15l-7-4-7 4V5c0-.5523.4477-1 1-1zm12 14.2768V5H6v13.2768l6-3.4286 6 3.4286z'],
  height: 24,
  width: 24,
});
